export const validateButtonsField = (value) =>
  value?.length === 0 && "Required";
